// Collapse component
export const collapse = 'js-collapse';

// CollapseElement component
export const anchor = 'js-anchor';
export const activeClass = 'm-collapse__element--active';
export const noFocusClass = 'm-collapse__element--nofocus';
